// Helper model for using sorting and filtering
export class Sort {
  public static readonly DIRECTION_ASC  = 'asc';
  public static readonly DIRECTION_DESC = 'desc';

  field: string;
  direction: string;

  constructor(field: string, direction: string) {
    this.field     = field;
    this.direction = direction;
  }
}
